import React from "react";
import GoogleMap, { type GoogleMapsProps } from "./GoogleMap/googlemap";
import SupportQuestionMark from "../supportbeacon/SupportQuestionMark";

interface Props extends GoogleMapsProps {
  height: number
  geoCode: server.dto.GeoCode
}

const GoogleMapOrError = (props: Props) => {
  const { height, geoCode, ...rest } = props;

  if (geoCode.hasError) {
    return <div className="flex align-center radius justify-center s1_gray panel-bg-color" style={{ height, minHeight: height, overflow: "hidden" }}>
      <div style={{ textAlign: "center" }}>
        <h1>{geoCode.userMessage}</h1>
        <div className="margin-top">
          <SupportQuestionMark articleId={geoCode.questionMark} />
        </div>
      </div>
    </div>;
  }

  return (
    <div className="radius" style={{
      height,
      minHeight: height,
      overflow: "hidden",
    }}>
      <GoogleMap {...rest} />
    </div>
  );
};

export default GoogleMapOrError;